import {
  LOGIN_SUCCESS,
  LOGOUT,
} from '../actions/reduxAction';

const INITIAL_STATE = {
  isLoggedIn: false,
  access_token: null,
  user: {
    active: false,
    currency: {},
    available_balance: '',
    current_currency_id: 0,
    email: '',
    id: 0,
    name: '',
    organization_id: 0,
    phone_active: false,
    profile_picture: null,
    registration_platform: 0,
    timezone: '',
    verified: false,
  },
  isLoading: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case LOGIN_SUCCESS:
      return {
        ...state,
        isLoggedIn: true,
        access_token: action.payload.data.access_token,
        user: {
          ...state.user,
          ...action.payload.data,
        },
      };

    case LOGOUT:
      return INITIAL_STATE;
    default:
      return state;
  }
};
